import LegalPage from "@/components/LegalPage";

export default function RefundPolicy() {
  return (
    <LegalPage title="Refund & Cancellation." updated="Feb 2026" testId="refund-page">
      <p>We understand that plans change. Our policy is deliberately simple and fair.</p>

      <h2>1. Cancellations by you</h2>
      <ul>
        <li><strong>More than 7 days before the event:</strong> full refund, minus the payment gateway fee (typically 2-3%).</li>
        <li><strong>3 to 7 days before:</strong> 50% refund or full credit that can be used against any future Carpe Diem programme within 6 months.</li>
        <li><strong>Less than 3 days before:</strong> no cash refund. We are happy to transfer your seat to a friend or family member on written notice.</li>
      </ul>

      <h2>2. Cancellations by us</h2>
      <p>If we cancel or reschedule an event, you will receive a <strong>100% refund</strong> — no questions asked — or the option to move your booking to a future date at no extra cost.</p>

      <h2>3. Exhibition space fees</h2>
      <p>Gallery space fees for exhibitions are non-refundable once dates have been confirmed and communicated to the artist. In case of extraordinary circumstances (health, bereavement, or acts beyond your control), we will do our best to accommodate a date change subject to availability.</p>

      <h2>4. Artwork purchases</h2>
      <p>Artworks purchased through our Buy Art programme are sold as-is. Each piece is unique. Returns are accepted only if the piece received differs materially from the description on the site or arrives damaged. Please raise a request within 7 days of delivery.</p>

      <h2>5. How to request a refund</h2>
      <p>Write to <a href="mailto:info@carpediemgoa.com">info@carpediemgoa.com</a> with your booking ID and reason. We reply within 2 business days. Once approved, refunds are processed to the original payment method and land in 5-7 working days.</p>

      <h2>6. Contact</h2>
      <p>For questions about this policy, please write to <a href="mailto:info@carpediemgoa.com">info@carpediemgoa.com</a> or call +91 98225 80152 (WhatsApp available).</p>
    </LegalPage>
  );
}
